import dayjs, { Dayjs } from 'dayjs';

import { API_GBP_CURRENCY_CODE } from '@constants/apiConstants';
import { CURRENCY_CODE } from '@constants/app';
import { DateFormat } from '@src/types/index';

import { isNullish } from './isNullish';

type FormatCurrency = (priceObject: {
  value: string | number;
  currency?: string;
  exponent?: number;
}) => string;

const formatNumber = (
  value: Nullable<number>,
  opts?: Intl.NumberFormatOptions
) => {
  if (isNullish(value)) {
    return '';
  }

  return value.toLocaleString('en-GB', opts);
};

const formatCurrency: FormatCurrency = (priceObject) => {
  const exponent = Math.pow(10, Number(priceObject.exponent)) || 1;

  let currency = priceObject.currency;

  if (currency === API_GBP_CURRENCY_CODE || !currency) {
    currency = CURRENCY_CODE;
  }

  return formatNumber(Number(priceObject.value) / exponent, {
    style: 'currency',
    currency,
  });
};

const formatCurrencyInPence: FormatCurrency = (priceObject) => {
  return formatNumber(Number(priceObject.value), {
    style: 'decimal',
    maximumFractionDigits: 3,
  }).concat('p');
};

const parseBirthdate = (value?: string | Dayjs) =>
  value
    ? dayjs(value, DateFormat.Numeric, true).format(DateFormat.ISO8601)
    : undefined;

export { formatNumber, formatCurrency, formatCurrencyInPence, parseBirthdate };
